import { useRive } from "@rive-app/react-canvas";
import useBreakpoints, { Breakpoint } from "../../../hooks/useBreakpoints";
import { RIVE_COVER_CENTER_LAYOUT } from "../../../constants/RiveConstants";

interface OutroRiveAnimationProps {
    src: string;
    stateMachines?: string;
}

const OutroRiveAnimation = (props: OutroRiveAnimationProps) => {
    const { getStyleBasedOnBreakpoint } = useBreakpoints();

    const { RiveComponent } = useRive({
        src: props.src,
        ...(props.stateMachines && { stateMachines: props.stateMachines }),
        autoplay: true,
        layout: RIVE_COVER_CENTER_LAYOUT,
    });

    return (
        <div className={getStyleBasedOnBreakpoint(Breakpoint.MD, "w-[250px] h-[250px]", "w-[200px] h-[200px]")}>
            <RiveComponent />
        </div>
    );
};

export default OutroRiveAnimation;
